import { customer_api } from '@redux/api';

export function getUser(Uid) {
	return customer_api.get(`/user/${Uid}`).then(({ data }) => {
		return data;
	});
}
